module.exports = __webpack_public_path__ + "static/media/arrow-down.8a782fc5.svg";